import { variants, LabelledLinkTheme } from '../LabelledLinkStyles.css';
import { multiVariantStyles } from './LabelledLinkVariants.css';

const LabelledLinkStableTheme: LabelledLinkTheme = {
  baseTheme: '',
  multiVariantStyles,
  variants
};

/*******************
 * Exports
 *******************/

export { LabelledLinkStableTheme };
